import { MainContainerTheme } from "Themes/Metrics"
import styled from "styled-components";
import { mobileSize } from "Themes/Metrics";

export const MainContainer = styled(MainContainerTheme)`
    display: flex;
    flex-direction: column;
    text-align: center;
`;
    
export const AuthContainer = styled.div`
    display: flex;
    margin: auto;
    width: 30%;
    @media ${mobileSize.large} {
        width: 100%;
        flex-direction: column;
    }
`;

export const LeftContainer = styled.div`
    flex: 1;
    padding: 50px;
    @media ${mobileSize.large} {
        padding-right: 0px;
    }
`;

export const SocialLoginContainer = styled.div`
    flex: 1;
    padding: 50px;
    @media ${mobileSize.large} {
        padding: 0px;
    }
`;

export const LoginContainer = styled.div`
    flex: 1;
    padding: 20px;
    padding-left: 10px;
    margin: 10px 0px;
    width: 100%;
    @media ${mobileSize.large} {
        border-bottom: solid 2px lightgray;
        padding: 10px 0px;
    }
`;

export const SignupContainer = styled.div`
    flex: 1;
    padding: 20px;
    padding-left: 10px;
    margin: 10px 0px;
    width: 100%;
    @media ${mobileSize.large} {
        border-bottom: solid 2px lightgray;
        padding: 10px 0px;
    }
`;